import React, { useState } from 'react';
import { Menu, X, ChefHat, Mail, Phone, MapPin, Clock, Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ImageCarousel from './components/imageCarousel';

const RestaurantWebsite = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState({ type: '', text: '' });
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [activeCategory, setActiveCategory] = useState('entradas-frias');
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const categoryMenuRef = React.useRef(null);

  const restaurantImages = [
    { src: '/images/exterior_entrada.jpg', alt: 'Ingreso principal' },
    { src: '/images/exterior_entrada_1.jpg', alt: 'Ingreso principal 2' },
    { src: '/images/salon_la_cana.jpg', alt: 'Salón cana' },
    { src: '/images/exterior_1.jpg', alt: 'Terraza Exterior' },
    { src: '/images/exterior_2.jpg', alt: 'Terraza Exterior 2' },
    { src: '/images/exterior_3.jpg', alt: 'Terraza Exterior 3' },
    { src: '/images/exterior_4.jpg', alt: 'Terraza Exterior 4' },
    { src: '/images/lounge.jpg', alt: 'Barra exterior coctel' }
    
  ];

  const nextImage = (e) => {
    if (e) e.stopPropagation();
    setCurrentImageIndex((prev) => (prev + 1) % restaurantImages.length);
  };

  const prevImage = (e) => {
    if (e) e.stopPropagation();
    setCurrentImageIndex((prev) => (prev - 1 + restaurantImages.length) % restaurantImages.length);
  };

  const openGallery = (index) => {
    console.log('Abriendo galería, índice:', index);
    setCurrentImageIndex(index);
    setIsGalleryOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeGallery = () => {
    console.log('Cerrando galería');
    setIsGalleryOpen(false);
    document.body.style.overflow = 'auto';
  };

  const handleCarouselClick = () => {
    console.log('Click en carousel detectado');
    openGallery(currentImageIndex);
  };

  React.useEffect(() => {
    if (!isGalleryOpen) return;
    
    const handleKeyPress = (e) => {
      if (e.key === 'Escape') closeGallery();
      if (e.key === 'ArrowRight') nextImage(e);
      if (e.key === 'ArrowLeft') prevImage(e);
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [isGalleryOpen, currentImageIndex]);


  const languages = [
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'pt', name: 'Português', flag: '🇧🇷' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' }
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsLangMenuOpen(false);
  };



  const menuCategories = [
  {
    id: 'entradas-frias',
    items: [
      { key: 'carpaccio-de-atun', imagen: 'carpaccio_de_atun.png', price: '$24.000' },
      { key: 'carpaccio-de-filete', imagen: 'carpaccio_de_filete.png', price: '$24.000' },
      { key: 'carpaccio-de-salmon', imagen: 'carpaccio_de_salmon.png', price: '$24.000' },
      { key: 'centolla-del-mar-del-sur', imagen: 'centolla_del_mar_del_sur.png', price: '$48.000' },
      { key: 'ceviche-acapulco', imagen: 'ceviche_de_acapulco.png', price: '$30.000' },
      { key: 'ceviche-de-locos', imagen: 'ceviche_de_locos.png', price: '$30.000' },
      { key: 'ceviche-de-pulpo', imagen: 'ceviche_de_pulpo.png', price: '$30.000' },
      { key: 'ceviche-estilo-mexicano', imagen: 'ceviche_estilo_mexicano.png', price: '$24.000' },
      { key: 'ceviche-de-salmon-acapulco', imagen: 'ceviche_de_salmon_acapulco.png', price: '$30.000' },
      { key: 'ceviche-tropical', imagen: 'ceviche_tropical.png', price: '$30.000' },
      { key: 'locos-en-salsa-verde', imagen: 'locos_en_salsa_verde.png', price: '$48.000' },
      { key: 'tartara-de-filete', imagen: 'tartara_de_filete.png', price: '$24.000' },
      { key: 'crudo-de-filete', imagen: 'crudo_de_filete.png', price: '$24.000' }
    ]
  },
  {
    id: 'entradas-calientes',
    items: [
      { key: 'brocheta-de-camarones-y-jamon-serrano', imagen: 'brocheta_de_camarones_y_jamon_serrano.png', price: '$30.000' },
      { key: 'camarones-ecuatorianos-a-la-primavera', imagen: 'camarones_ecuatorianos_a_la_primavera.png', price: '$24.000' },
      { key: 'camarones-al-ajillo', imagen: 'camarones_ecuatorianos.png', price: '$24.000' },
      { key: 'camarones-al-olivo', imagen: 'camarones_ecuatorianos.png', price: '$24.000' },
      { key: 'camarones-al-pil-pil', imagen: 'camarones_al_pilpil.png', price: '$24.000' },
      { key: 'langosta-de-juan-fernandez', imagen: 'langosta_de_juan_fernandez.png', price: '$119.000' },
      { key: 'machas-a-la-parmesana', imagen: 'machas_a_la_parmesana.png', price: '$24.000' },
      { key: 'ostiones-a-la-parmesana', imagen: 'ostiones_a_la_parmesana.png', price: '$25.000' },
      { key: 'pulpo-a-la-parrilla', imagen: 'pulpo_a_la_parrilla.png', price: '$36.000' },
      { key: 'pulpo-salteado-al-ajillo', imagen: 'pulpo_a_la_parrilla.png', price: '$36.000' },
      { key: 'pulpo-salteado-al-pil-pil', imagen: 'pulpo_a_la_parrilla.png', price: '$36.000' },
      { key: 'centolla-entera', imagen: 'centolla_entera.png', price: '$380.000' }
    ]
  },
  {
    id: 'agregados',
    items :[
      {key: 'anillos-de-cebolla', imagen:'anillos-de-cebolla.png',price:'$6.900'},
      {key: 'arroz', imagen:'arroz.png',price:'$4.000'},
      {key: 'champinones-salteados', imagen:'champinones-salteados.png',price:'$8.900'},
      {key: 'choclo-a-la-crema', imagen:'choclo-a-la-crema.png',price:'$8.900'},
      {key: 'espinacas-a-la-crema', imagen:'espinacas-a-la-crema.png',price:'$7.000'},
      {key: 'panache-de-verduras', imagen:'panache-de-verduras.png',price:'$6.000'},
      {key: 'papas-a-la-crema-acida', imagen:'papas-a-la-crema-acida.png',price:'$6.900'},
      {key: 'papas-chauchas', imagen:'papas-chauchas.png',price:'$7.000'},
      {key: 'papas-cocidas', imagen:'papas-cocidas.png',price:'$5.000'},
      {key: 'papas-duquesas', imagen:'papas-duquesas.png',price:'$8.900'},
      {key: 'papas-fritas', imagen:'papas-fritas.png',price:'$6.900'},
      {key: 'papas-hilo', imagen:'papas-hilo.png',price:'$6.900'},
      {key: 'papas-salteadas', imagen:'papas-salteadas.png',price:'$5.000'},
      {key: 'pure-de-papas', imagen:'pure-de-papas.png',price:'$6.900'},
      {key: 'pure-de-zapallo', imagen:'pure-de-zapallo.png',price:'$6.900'},
      {key: 'pure-gratinado', imagen:'pure-gratinado.png',price:'$6.900'},
      
    ]
  },
  {
    id: 'sopas-cremas',
    items: [
      { key: 'ajiaco', imagen: 'ajiaco.png', price: '$25.000' },
      { key: 'calderete-de-langosta', imagen: 'calderete_de_langosta_de_juan_fernandez.png', price: '$60.000' },
      { key: 'caldillo-de-congrio', imagen: 'caldillo_de_congrio.png', price: '$24.000' },
      { key: 'crema-de-centolla', imagen: 'crema_de_centolla.png', price: '$24.000' },
      { key: 'crema-de-puerros', imagen: 'crema_de_puerros.png', price: '$18.000' },
      { key: 'crema-de-zapallo', imagen: 'crema_de_puerros.png', price: '$18.000' },
      { key: 'crema-de-tomate', imagen: 'crema_de_puerros.png', price: '$18.000' },
      { key: 'crema-de-esparragos', imagen: 'crema_de_puerros.png', price: '$18.000' },
      { key: 'sopa-aquarium', imagen: 'sopa_aquarium.png', price: '$35.000' },
      { key: 'consome-ave-reina', imagen: 'consome_ave_reina.png', price: '$18.000' }
    ]
  },
  {
    id: 'ensaladas',
    items: [
      { key: 'ensalada-cesar', imagen: 'ensalada_cesar.png', price: '$16.000' },
      { key: 'ensalada-cesar-con-camarones', imagen: 'ensalada_cesar_con_camarones.png', price: '$24.000' },
      { key: 'ensalada-cesar-con-pollo', imagen: 'ensalada_cesar_con_pollo.png', price: '$24.000' },
      { key: 'ensalada-cesar-con-pollo-y-camarones', imagen: 'ensalada_cesar_con_pollo_y_camarones.png', price: '$24.000' },
      { key: 'ensalada-de-manzanas', imagen: 'ensalada_de_manzanas.png', price: '$12.000' },
      { key: 'ensalada-griega', imagen: 'ensalada_griega.png', price: '$15.000' },
      { key: 'ensalada-silvestre', imagen: 'ensalada_silvestre.png', price: '$15.000' },
      { key: 'ensalada-verde', imagen: 'ensalada_verde.png', price: '$15.000' }
    ]
  },
  {
    id: 'carnes',
    items: [
      { key: 'asado-de-tira-angus-600-grs', imagen: 'asado_de_tira_angus_600_grs.png', price: '$36.000' },
      { key: 'asado-de-tira-angus-800-grs', imagen: 'asado_de_tira_angus_800_grs.png', price: '$42.000' },
      { key: 'baby-beef-angus-450-grs', imagen: 'baby_beef_angus_450_grs.png', price: '$40.000' },
      { key: 'bife-chorizo-wagyu-400-grs', imagen: 'bife_chorizo_wagyu_400_grs.png', price: '$96.000' },
      { key: 'bife-chorizo-angus-400-grs', imagen: 'bife_chorizo_angus_400_grs.png', price: '$36.000' },
      { key: 'bife-relleno-solocarnes-400-grs', imagen: 'bife_relleno_solocarnes_400_grs.png', price: '$40.000' },
      { key: 'cordero-de-bulnes-450-grs', imagen: 'cordero_de_bulnes_450_grs.png', price: '$40.000' },
      { key: 'entrana-300-grs', imagen: 'entrana_de_wagyu_400_grs.png', price: '$40.000' },
      { key: 'entrana-de-wagyu-400-grs', imagen: 'entrana_de_wagyu_400_grs.png', price: '$70.000' },
      { key: 'filete-aquarium-300-grs', imagen: 'filete_aquarium_300_grs.png', price: '$36.000' },
      { key: 'filete-grille-300-grs', imagen: 'filete_aquarium_300_grs.png', price: '$30.000' },
      { key: 'porterhouse-steak-700-grs', imagen: 'porterhouse_steak_700_grs.png', price: '$48.000' },
      { key: 'plateada-al-horno', imagen: 'plateada_al_horno.png', price: '$24.000' },
      { key: 'tomahawk-1-5-kgs', imagen: 'tomahawk_1_5_kgs.png', price: '$120.000' }
    ]
  },
  {
    id: 'pescados',
    items: [
      { key: 'atun-del-ecuador', imagen: 'atun_del_ecuador.png', price: '$24.000' },
      { key: 'congrio-dorado', imagen: 'congrio_dorado.png', price: '$24.000' },
      { key: 'corvina-con-camarones-salteados', imagen: 'corvina_con_camarones_salteados.png', price: '$30.000' },
      { key: 'corvina-grille', imagen: 'corvina_grille.png', price: '$24.000' },
      { key: 'corvina-roulade', imagen: 'corvina_roulade.png', price: '$30.000' },
      { key: 'merluza-austral-grille', imagen: 'merluza_austral_grille.png', price: '$24.000' },
      { key: 'salmon-grille-con-camarones', imagen: 'salmon_grille_con_camarones_salteados.png', price: '$30.000' },
      { key: 'salmon-grille', imagen: 'salmon_grille.png', price: '$24.000' }
    ]
  },
  {
    id: 'pastas',
    items: [
      { key: 'canelones-con-centolla', imagen: 'canelones_rellenos_con_centolla.png', price: '$42.000' },
      { key: 'canelones-con-locos', imagen: 'canelones_rellenos_con_locos.png', price: '$42.000' },
      { key: 'canelones-con-pollo', imagen: 'canelones_rellenos_con_centolla.png', price: '$25.000' },
      { key: 'espagueti', imagen: 'espagueti.png', price: '$6.000' },
      { key: 'espagueti-al-pesto', imagen: 'espagueti_al_pesto.png', price: '$12.000' },
      { key: 'lasana-bolonesa', imagen: 'lasana_bolonesa.png', price: '$18.000' },
      { key: 'noquis-bolonesa-18-unidades', imagen: 'noquis_bolonesa_18_unidades.png', price: '$18.000' },
      { key: 'pappardelle-fruto-di-mare', imagen: 'pappardelle_fruto_di_mare.png', price: '$20.000' },
      { key: 'ravioles-con-espinacas', imagen: 'ravioles_rellenos_con_espinacas.png', price: '$14.000' },
      { key: 'sorrentinos-de-centolla', imagen: 'sorrentinos_de_centolla.png', price: '$26.000' }
    ]
  },
  {
    id: 'veganos',
    items: [
      { key: 'croquetas-de-lentejas-con-salsa-pomodoro', imagen: 'croquetas_de_lentejas_con_salsa_pomodoro.png', price: '$15.000' },
      { key: 'hamburguesa-de-garbanzos', imagen: 'hamburguesa_de_garbanzos_con_ensalada_fresca.png', price: '$12.000' },
      { key: 'quinotto-de-champinones', imagen: 'quinotto_de_champinones_cebollin_y_almendras_tostadas.png', price: '$12.000' }
    ]
  },
  {
    id: 'celiacos',
    items: [
      { key: 'espirales-de-arroz-con-camarones', imagen: 'espirales_de_arroz_a_la_italiana_con_camaromes_salteados.png', price: '$14.000' },
      { key: 'lomo-liso-con-papas-rusticas', imagen: 'lomo_liso_grillado_con_papas_rusticas.png', price: '$30.000' },
      { key: 'merluza-austral-con-verduras', imagen: 'merluza_austral_con_salteado_de_verduras_y_nueces.png', price: '$26.000' }
    ]
  },

  {
    id: 'postres',
    items: [
      { key: 'churros-caseros', imagen: 'churros_caseros.png', price: '$12.000' },
      { key: 'creme-brulee', imagen: 'creme_brulee.png', price: '$11.000' },
      { key: 'globo-de-chocolate', imagen: 'globo_de_chocolate.png', price: '$24.000' },
      { key: 'helados-artesanales', imagen: 'helados_artesanales.png', price: '$9.000' },
      { key: 'leche-asada', imagen: 'leche_asada.png', price: '$9.000' },
      { key: 'panqueque-celestino', imagen: 'panqueque_celestino.png', price: '$12.000' },
      { key: 'papayas-al-jugo', imagen: 'papayas_al_jugo.png', price: '$9.000' },
      { key: 'picarones', imagen: 'picarones.png', price: '$8.000' },
      { key: 'suspiro-limeno', imagen: 'suspiro_limeno.png', price: '$9.000' },
      { key: 'tiramisu', imagen: 'tiramisu.png', price: '$9.000' },
      { key: 'volcan-de-chocolate', imagen: 'volcan_de_chocolate.png', price: '$9.000' }
    ]
  },
  {
    id: 'salsas',
    items: [
      { key: 'salsa-4-pimientas', imagen: 'salsa_4_pimientas.png', price: '$6.000' },
      { key: 'salsa-al-pesto', imagen: 'salsa_al_pesto.png', price: '$6.000' },
      { key: 'salsa-alfredo', imagen: 'salsa_alfredo.png', price: '$6.000' },
      { key: 'salsa-arrabiata', imagen: 'salsa_arrabiata.png', price: '$6.000' },
      { key: 'salsa-bolonesa', imagen: 'salsa_bolonesa.png', price: '$6.000' },
      { key: 'salsa-de-centolla', imagen: 'salsa_de_centolla.png', price: '$12.000' },
      { key: 'salsa-de-locos', imagen: 'salsa_de_locos.png', price: '$11.000' },
      { key: 'salsa-de-mostaza', imagen: 'salsa_de_mostaza.png', price: '$6.000' },
      { key: 'salsa-de-pulpo', imagen: 'salsa_de_pulpo.png', price: '$18.000' },
      { key: 'salsa-pomodoro', imagen: 'salsa_pomodoro.png', price: '$6.000' }
    ]
  },
  {
    id: 'tablas',
    items: [
      { key: 'tabla-aquarium-4-locos', imagen: 'tabla_aquarium_4_locos.png', price: '$120.000' },
      { key: 'tabla-aquarium-premium', imagen: 'tabla_aquarium_premium.png', price: '$170.000' },
      { key: 'tabla-de-carnes-y-guacamole', imagen: 'tabla_de_carnes_y_guacamole.png', price: '$72.000' },
      { key: 'tabla-mixta-solocarnes', imagen: 'tabla_mixta_solocarnes.png', price: '$84.000' }
    ]
  },
  // Vinos
  {
    id: 'vinos',
    items: [
      // COPAS DE VINO
      { key: 'copa-arboleda-chardonnay', price: '$9.500' },
      { key: 'copa-san-pedro-1865-sauvignon-blanc', price: '$7.500' },
      { key: 'copa-montes-alpha-carmenere', price: '$9.500' },
      { key: 'copa-max-errazuriz', price: '$7.500' },
      
      // CHARDONNAY
      { key: 'arboleda-chardonnay', price: '$38.000' },
      { key: 'caliterra-chardonnay', price: '$15.000' },
      { key: 'casa-silva-chardonnay', price: '$18.000' },
      { key: 'concha-y-toro-chardonnay', price: '$33.000' },
      { key: 'errazuriz-max-chardonnay', price: '$31.000' },
      { key: 'montes-alpha-chardonnay', price: '$38.000' },
      { key: 'san-pedro-castillo-chardonnay', price: '$18.000' },
      { key: 'tarapaca-chardonnay', price: '$24.000' },
      { key: 'terranoble-chardonnay', price: '$27.000' },
      
      // SAUVIGNON BLANC
      { key: 'arboleda-sauvignon-blanc', price: '$38.000' },
      { key: 'casa-silva-sauvignon-blanc', price: '$18.000' },
      { key: 'errazuriz-max-sauvignon-blanc', price: '$31.000' },
      { key: 'san-pedro-1865-sauvignon-blanc', price: '$30.000' },
      { key: 'san-pedro-castillo-sauvignon-blanc', price: '$18.000' },
      { key: 'santa-cruz-chaman-sauvignon-blanc', price: '$27.000' },
      { key: 'tarapaca-sauvignon-blanc', price: '$24.000' },
      
      // CARMENERE
      { key: 'arboleda-carmenere', price: '$38.000' },
      { key: 'caliterra-tributo-carmenere', price: '$21.000' },
      { key: 'caliterra-carmenere', price: '$15.000' },
      { key: 'casa-silva-carmenere', price: '$28.000' },
      { key: 'concha-y-toro-carmenere', price: '$33.000' },
      { key: 'errazuriz-max-carmenere', price: '$31.000' },
      { key: 'montes-alpha-carmenere', price: '$38.000' },
      { key: 'perez-cruz-carmenere', price: '$40.000' },
      { key: 'san-pedro-1865-carmenere', price: '$30.000' },
      { key: 'san-pedro-castillo-carmenere', price: '$18.000' },
      { key: 'santa-cruz-chaman-carmenere', price: '$27.000' },
      { key: 'santa-ema-carmenere', price: '$22.000' },
      { key: 'terranoble-carmenere', price: '$27.000' },
      
      // CABERNET SAUVIGNON
      { key: 'arboleda-cabernet-sauvignon', price: '$38.000' },
      { key: 'caliterra-tributo-cabernet', price: '$21.000' },
      { key: 'caliterra-cabernet', price: '$15.000' },
      { key: 'casa-silva-cabernet', price: '$28.000' },
      { key: 'concha-y-toro-cabernet', price: '$33.000' },
      { key: 'errazuriz-max-cabernet', price: '$31.000' },
      { key: 'montes-alpha-cabernet', price: '$38.000' },
      { key: 'perez-cruz-cabernet-piedra-seca', price: '$50.000' },
      { key: 'perez-cruz-cabernet-gran-reserva', price: '$23.000' },
      { key: 'san-pedro-1865-cabernet', price: '$30.000' },
      { key: 'san-pedro-castillo-cabernet', price: '$18.000' },
      { key: 'santa-ema-cabernet', price: '$22.000' },
      { key: 'tarapaca-etiqueta-negra', price: '$38.000' },
      { key: 'tarapaca-cabernet', price: '$24.000' },
      { key: 'terranoble-cabernet', price: '$27.000' },
      
      // MERLOT
      { key: 'caliterra-merlot', price: '$15.000' },
      { key: 'concha-y-toro-merlot', price: '$33.000' },
      { key: 'montes-alpha-merlot', price: '$38.000' },
      { key: 'san-pedro-1865-merlot', price: '$30.000' },
      { key: 'santa-ema-merlot', price: '$22.000' },
      
      // PINOT NOIR
      { key: 'arboleda-pinot-noir', price: '$38.000' },
      { key: 'montes-alpha-pinot-noir', price: '$38.000' },
      
      // MALBEC
      { key: 'caliterra-tributo-malbec', price: '$21.000' },
      { key: 'errazuriz-max-malbec', price: '$31.000' },
      { key: 'montes-alpha-malbec', price: '$38.000' },
      { key: 'santa-cruz-chaman-malbec', price: '$27.000' },
      
      // SYRAH
      { key: 'arboleda-syrah', price: '$38.000' },
      { key: 'caliterra-tributo-syrah', price: '$21.000' },
      { key: 'montes-alpha-syrah', price: '$38.000' },
      
      // MEZCLAS
      { key: 'casa-silva-quinta-generacion', price: '$52.000' },
      { key: 'montgras-quatro', price: '$30.000' },
      { key: 'santa-cruz-tupu', price: '$57.000' },
      { key: 'santa-ema-barrel-reserve', price: '$23.000' },
      { key: 'santa-ema-catalina', price: '$70.000' },
      { key: 'tarapaca-etiqueta-azul', price: '$85.000' },
      { key: 'tarapaca-late-harvest', price: '$12.000' },
      
      // VINOS ITALIANOS
      { key: 'cantine-ceci-lambrusco', price: '$35.000' },
      
      // PREMIUM Y SUPER PREMIUM
      { key: 'casa-lapostolle-clos-apalta', price: '$390.000' },
      { key: 'concha-y-toro-don-melchor', price: '$600.000' },
      { key: 'errazuriz-don-maximiano', price: '$230.000' },
      { key: 'miguel-torres-manso-de-velasco', price: '$150.000' },
      { key: 'montes-alpha-m', price: '$290.000' },
      { key: 'sena', price: '$400.000' },
      { key: 'montes-purple-angel', price: '$290.000' },
      { key: 'vinedo-chadwick', price: '$700.000' }
    ]
  },

  // CERVEZAS
  {
    id: 'cervezas',
    items: [
      // CERVEZAS REGULARES
      { key: 'austral-calafate', price: '$4.000' },
      { key: 'austral-lager', price: '$4.000' },
      { key: 'budweiser', price: '$4.000' },
      { key: 'corona-extra', price: '$4.000' },
      { key: 'erdinger-weissbier', price: '$5.000' },
      { key: 'heineken', price: '$4.000' },
      { key: 'kross-golden-pale-ale', price: '$6.000' },
      { key: 'kunstmann-lager', price: '$4.000' },
      { key: 'kunstmann-torobayo-330', price: '$4.000' },
      { key: 'kunstmann-torobayo-500', price: '$6.000' },
      { key: 'kunstmann-gran-torobayo', price: '$7.000' },
      { key: 'kunstmann-bock', price: '$4.000' },
      { key: 'kunstmann-miel', price: '$4.000' },
      
      // CERVEZAS BELGAS
      { key: 'delirium-christmas', price: '$9.500' },
      { key: 'delirium-nocturnum', price: '$9.500' },
      { key: 'delirium-tremens', price: '$9.500' },
      
      // CERVEZAS SIN ALCOHOL
      { key: 'erdinger-alkoholfrei', price: '$5.000' },
      { key: 'grolsch-non-alcoholic', price: '$4.000' },
      { key: 'heineken-sin-alcohol', price: '$4.000' },
      { key: 'kunstmann-sin-alcohol', price: '$4.000' }
    ]
  },

  // COCTELERÍA
  {
    id: 'cocteleria',
    items: [
      // SPRITZ
      { key: 'spritz-aperol', price: '$8.000' },
      { key: 'spritz-chambord', price: '$10.000' },
      { key: 'spritz-kir-royal', price: '$6.000' },
      { key: 'spritz-limoncello', price: '$11.000' },
      { key: 'spritz-ramazzotti', price: '$9.000' },
      { key: 'spritz-saint-germain', price: '$12.000' },
      
      // SOURS
      { key: 'pisco-sour', price: '$7.000' },
      { key: 'pisco-sour-doble', price: '$14.000' },
      { key: 'pisco-sour-sabores', price: '$7.000' },
      { key: 'pisco-sour-rica-rica', price: '$7.000' },
      { key: 'pisco-sour-kappa', price: '$20.000' },
      { key: 'pisco-sour-waqar', price: '$18.000' },
      { key: 'amaretto-sour', price: '$11.000' },
      { key: 'chardonnay-sour', price: '$6.000' },
      { key: 'jerez-sour', price: '$6.000' },
      { key: 'vodka-sour', price: '$6.000' },
      { key: 'whisky-sour', price: '$7.000' },
      { key: 'whisky-sour-black-label', price: '$15.000' },
      { key: 'whisky-sour-chivas-18', price: '$30.000' },
      
      // MOJITO
      { key: 'mojito-tradicional', price: '$5.000' },
      { key: 'mojito-sabores', price: '$6.000' },
      { key: 'mojito-menta-albahaca', price: '$6.000' },
      { key: 'mojito-jack', price: '$11.000' },
      { key: 'mojito-jaggermeister', price: '$8.000' },
      { key: 'mojito-espumante', price: '$5.000' },
      { key: 'mojito-sin-alcohol', price: '$4.000' },
      
      // COCKTAILS CLÁSICOS
      { key: 'alexander', price: '$6.000' },
      { key: 'alexander-night', price: '$6.000' },
      { key: 'bitter-a-la-francesa', price: '$6.000' },
      { key: 'bitter-batido', price: '$6.000' },
      { key: 'bloody-mary', price: '$8.000' },
      { key: 'caipirinha', price: '$5.000' },
      { key: 'caipirisima', price: '$5.000' },
      { key: 'caipiroska', price: '$5.000' },
      { key: 'campari-naranja', price: '$8.000' },
      { key: 'campari-soda', price: '$8.000' },
      { key: 'campari-tonica', price: '$8.000' },
      { key: 'clavo-oxidado', price: '$10.000' },
      { key: 'cosmopolitan', price: '$9.000' },
      { key: 'daiquiri-tradicional', price: '$6.000' },
      { key: 'daiquiri-sabores', price: '$6.000' },
      { key: 'el-padrino', price: '$12.000' },
      { key: 'john-collins', price: '$6.000' },
      { key: 'manhattan', price: '$7.000' },
      { key: 'martini-dry', price: '$9.000' },
      { key: 'martini-expresso', price: '$9.000' },
      { key: 'berlin-mule', price: '$11.000' },
      { key: 'london-mule', price: '$12.000' },
      { key: 'moscow-mule', price: '$10.000' },
      { key: 'negroni', price: '$8.000' },
      { key: 'old-fashioned', price: '$6.000' },
      { key: 'pina-colada', price: '$10.000' },
      { key: 'primavera-con-licor', price: '$8.000' },
      { key: 'primavera-sin-licor', price: '$6.000' },
      { key: 'ruso-blanco', price: '$7.000' },
      { key: 'ruso-negro', price: '$7.000' },
      { key: 'tequila-margarita', price: '$6.500' },
      { key: 'tequila-sabores', price: '$6.500' },
      { key: 'tom-collins', price: '$8.000' },
      { key: 'vaina', price: '$6.000' },
      { key: 'vodkatini', price: '$6.000' },
      { key: 'jugo-tomates-alinos', price: '$5.000' },
      { key: 'borgona', price: '$5.000' },
      { key: 'sangria', price: '$5.000' },
      { key: 'sangria-en-jerez', price: '$5.000' },
      { key: 'chelada', price: '$1.000' },
      { key: 'michelada', price: '$1.000' },
      
      // GIN
      { key: 'beefeater-dry', price: '$7.000' },
      { key: 'beefeater-pink', price: '$7.500' },
      { key: 'bombay-sapphire', price: '$6.500' },
      { key: 'bulldog', price: '$9.000' },
      { key: 'hendricks', price: '$12.000' },
      { key: 'hendricks-lunar', price: '$12.000' },
      { key: 'mombasa-club', price: '$15.000' },
      { key: 'mombasa-strawberry', price: '$15.000' },
      { key: 'tanqueray', price: '$7.500' },
      { key: 'tanqueray-ten', price: '$15.000' },
      { key: 'london-no1', price: '$14.000' },
      
      // BRANDY
      { key: 'agustin-blazquez', price: '$8.000' },
      { key: 'carlos-i', price: '$22.000' },
      { key: 'lepanto', price: '$20.000' },
      { key: 'torres-10', price: '$10.000' },
      { key: 'torres-20', price: '$13.000' },
      
      // COGNAC
      { key: 'camus-xo', price: '$43.000' },
      { key: 'courvoisier-xo', price: '$48.000' },
      { key: 'hennessy-vs', price: '$20.000' },
      { key: 'hennessy-vsop', price: '$37.000' },
      { key: 'hennessy-xo', price: '$80.000' },
      { key: 'martell-xo', price: '$85.000' },
      { key: 'remy-martin-vsop', price: '$23.000' },
      { key: 'remy-martin-xo', price: '$80.000' },
      
      // OPORTO / JEREZ
      { key: 'osborne-tawny', price: '$10.000' },
      { key: 'osborne-fino-quinta', price: '$6.000' },
      { key: 'osborne-oporto-10', price: '$14.000' },
      { key: 'tio-pepe', price: '$6.000' },
      { key: 'zalamero', price: '$5.000' },
      
      // BAJATIVOS
      { key: 'amarula', price: '$7.000' },
      { key: 'baileys', price: '$6.500' },
      { key: 'cointreau', price: '$12.000' },
      { key: 'licor-43', price: '$8.000' },
      { key: 'disaronno', price: '$8.500' },
      { key: 'drambuie', price: '$8.000' },
      { key: 'frangelico', price: '$6.500' },
      { key: 'fernet-branca', price: '$5.500' },
      { key: 'fernet-rossard', price: '$5.000' },
      { key: 'grand-marnier', price: '$15.000' },
      { key: 'jagermeister', price: '$5.000' },
      { key: 'kahlua', price: '$6.500' },
      { key: 'licor-araucano', price: '$6.000' },
      { key: 'limoncello', price: '$11.000' },
      { key: 'sambuca', price: '$9.000' },
      { key: 'menthe-verte', price: '$6.000' },
      { key: 'ouzo', price: '$5.000' },
      { key: 'pernord', price: '$5.000' },
      { key: 'saint-germain', price: '$9.500' },
      { key: 'sheridans', price: '$11.000' },
      
      // PISCOS
      { key: 'alto-carmen-especial', price: '$5.000' },
      { key: 'alto-carmen-reservado', price: '$6.000' },
      { key: 'alto-carmen-transparente', price: '$6.000' },
      { key: 'alto-carmen-cumbre', price: '$9.000' },
      { key: 'black-heron', price: '$8.000' },
      { key: 'capel', price: '$5.000' },
      { key: 'horcon-especial', price: '$6.000' },
      { key: 'horcon-reservado', price: '$8.000' },
      { key: 'kappa', price: '$14.000' },
      { key: 'mistral-35', price: '$5.000' },
      { key: 'mistral-40', price: '$6.000' },
      { key: 'mistral-nobel-fire', price: '$6.000' },
      { key: 'mistral-nobel-reservado', price: '$6.000' },
      { key: 'mistral-nobel-barrica', price: '$6.000' },
      { key: 'mistral-gran-nobel', price: '$11.000' },
      { key: 'republicano-40', price: '$6.000' },
      { key: 'republicano-triple', price: '$6.000' },
      { key: 'waqar', price: '$13.000' },
      
      // RON
      { key: 'bacardi-blanca', price: '$5.000' },
      { key: 'bacardi-8', price: '$7.000' },
      { key: 'casa-bacardi', price: '$18.000' },
      { key: 'havana-7', price: '$9.000' },
      { key: 'matusalem', price: '$7.000' },
      { key: 'pampero', price: '$15.000' },
      { key: 'zacapa-12', price: '$15.000' },
      { key: 'zacapa-23', price: '$25.000' },
      { key: 'zacapa-xo', price: '$56.000' },
      
      // TEQUILA
      { key: '1800-silver', price: '$13.000' },
      { key: '1800-reposado', price: '$13.000' },
      { key: 'don-julio', price: '$24.000' },
      { key: 'herradura', price: '$14.000' },
      { key: 'jose-cuervo-silver', price: '$6.000' },
      { key: 'jose-cuervo-reposado', price: '$10.000' },
      { key: 'patron-anejo', price: '$20.000' },
      
      // CACHAZA
      { key: 'cachaca-51', price: '$2.000' },
      { key: 'velho-barreiro', price: '$2.000' },
      
      // VODKA
      { key: 'absolut-blue', price: '$6.500' },
      { key: 'absolut-sabores', price: '$6.500' },
      { key: 'absolut-elyx', price: '$13.500' },
      { key: 'grey-goose', price: '$12.000' },
      { key: 'grey-goose-sabores', price: '$12.000' },
      { key: 'grey-goose-vx', price: '$40.000' },
      { key: 'stolichnaya', price: '$5.000' },
      { key: 'stolichnaya-vainilla', price: '$5.000' },
      { key: 'stolichnaya-elit', price: '$14.000' },
      
      // WHISKY
      { key: 'chivas-12', price: '$11.000' },
      { key: 'chivas-18', price: '$25.000' },
      { key: 'chivas-21', price: '$75.000' },
      { key: 'glenfiddich-12', price: '$17.000' },
      { key: 'glenfiddich-15', price: '$40.000' },
      { key: 'jack-gentleman', price: '$17.000' },
      { key: 'jack-sinatra', price: '$46.000' },
      { key: 'jack-single-barrel', price: '$20.000' },
      { key: 'jack-no7', price: '$10.000' },
      { key: 'jack-apple', price: '$10.000' },
      { key: 'jack-fire', price: '$10.000' },
      { key: 'jack-honey', price: '$10.000' },
      { key: 'jameson', price: '$9.000' },
      { key: 'jw-red', price: '$7.000' },
      { key: 'jw-black', price: '$11.000' },
      { key: 'jw-double-black', price: '$18.000' },
      { key: 'jw-gold', price: '$30.000' },
      { key: 'jw-swing', price: '$25.000' },
      { key: 'jw-blue', price: '$80.000' },
      { key: 'dalmore-12', price: '$30.000' },
      { key: 'dalmore-15', price: '$50.000' },
      { key: 'glenlivet-founders', price: '$14.000' },
      { key: 'glenlivet-12', price: '$16.000' },
      { key: 'macallan-12', price: '$45.000' },
      { key: 'macallan-classic', price: '$70.000' },
      { key: 'grants-blended-scotch', price: '$12.000'}
    ]
  },

  // ESPUMANTES
  {
    id: 'espumantes',
    items: [
      // COPA DE ESPUMANTE
      { key: 'copa-espumante', price: '$5.000' },
      
      // ESPUMANTES
      { key: 'espumante-chandon-brut', price: '$25.000' },
      { key: 'espumante-chandon-demi-sec', price: '$25.000' },
  
      { key: 'espumante-donoso-brut', price: '$20.000' },
  
      { key: 'espumante-riccadonna-asti', price: '$25.000' },
      { key: 'espumante-riccadonna-chardonnay', price: '$25.000' },
      { key: 'espumante-riccadonna-moscato', price: '$25.000' },
      { key: 'espumante-riccadonna-prosecco', price: '$25.000' },
      { key: 'espumante-undurraga', price: '$15.000' },
      { key: 'espumante-valdivieso', price: '$55.000' },
      
      
      // CHAMPAGNE
      { key: 'champagne-dom-perignon', price: '$450.000' },
      
      // VALLE DEL ITATA
      { key: 'espumante-berta-extra-brut', price: '$23.000' },
      { key: 'espumante-berta-dulce-doux', price: '$23.000' }
    ]
  },

  // JUGOS Y BEBIDAS
  {
    id: 'jugos-bebidas',
    items: [
      // AGUAS MINERALES
      { key: 'acqua-panna', price: '$6.000' },
      { key: 'agua-vital-330', price: '$3.500' },
      { key: 'san-pellegrino-250', price: '$5.000' },
      { key: 'san-pellegrino-505', price: '$6.000' },
      
      // AGUAS TÓNICAS Y ENERGÉTICAS
      { key: 'fentimans-ginger-beer', price: '$5.000' },
      { key: 'fentimans-tonic-water', price: '$5.000' },
      { key: 'thomas-henry-ginger-beer', price: '$5.000' },
      { key: 'thomas-henry-tonic', price: '$5.000' },
      { key: 'canada-dry-tonica-zero', price: '$3.500' },
      { key: 'schweppes-tonica', price: '$3.500' },
      { key: 'red-bull', price: '$4.000' },
      { key: 'red-bull-sugar-free', price: '$4.000' },
      
      // JUGOS NATURALES
      { key: 'jugos-naturales', price: '$4.000' },
      { key: 'jugo-tomate-alinos', price: '$5.000' },
      
      // LIMONADAS
      { key: 'limonada-menta-frambuesa', price: '$5.000' },
      { key: 'limonada-con-mineral', price: '$3.500' },
      { key: 'limonada-con-menta', price: '$4.000' },
      { key: 'limonada-menta-jengibre', price: '$4.000' },
      
      // BEBIDAS DE FANTASÍA
      { key: 'coca-cola', price: '$3.500' },
      { key: 'fanta', price: '$3.500' },
      { key: 'sprite', price: '$3.500' },
      { key: 'schweppes-ginger-ale', price: '$3.500' },
      { key: 'nectar-andina', price: '$3.500' }
    ]
  },
];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.phone || !formData.message) {
    setSubmitMessage({
      type: 'error',
      text: t('contact.form.errorEmpty') || 'Por favor completa todos los campos'
    });
    return;
  }

  // Validar email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(formData.email)) {
    setSubmitMessage({
      type: 'error',
      text: t('contact.form.errorEmail') || 'Por favor ingresa un email válido'
    });
    return;
  }

  setIsSubmitting(true);
  setSubmitMessage({ type: '', text: '' });

  try {
    // IMPORTANTE: Cambia esta URL por la URL de tu servidor donde subirás el archivo PHP
    const response = await fetch('https://solocarnes.cl/enviar-contacto.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });

    const data = await response.json();

    if (response.ok && data.success) {
      setSubmitMessage({
        type: 'success',
        text: data.message || t('contact.form.success') || 'Mensaje enviado correctamente. Te contactaremos pronto.'
      });
      
      // Limpiar formulario
      setFormData({ name: '', email: '', phone: '', message: '' });
      
      // Opcional: Hacer scroll suave hacia el mensaje de éxito
      setTimeout(() => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      throw new Error(data.message || 'Error al enviar el mensaje');
    }
    } catch (error) {
      console.error('Error:', error);
      setSubmitMessage({
        type: 'error',
        text: error.message || t('contact.form.error') || 'Error al enviar el mensaje. Por favor intenta nuevamente.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const scrollToSection = (section) => {
    setActiveSection(section);
    setIsMenuOpen(false);
    document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToCategory = (categoryId) => {
    setActiveCategory(categoryId);
    const element = document.getElementById(`category-${categoryId}`);
    if (element) {
      const offset = 180;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  React.useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '-180px 0px -50% 0px',
      threshold: 0
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const categoryId = entry.target.id.replace('category-', '');
          setActiveCategory(categoryId);
          
          const categoryButton = document.getElementById(`btn-${categoryId}`);
          if (categoryButton && categoryMenuRef.current) {
            const menuContainer = categoryMenuRef.current;
            const buttonLeft = categoryButton.offsetLeft;
            const buttonWidth = categoryButton.offsetWidth;
            const menuWidth = menuContainer.offsetWidth;
            const scrollLeft = buttonLeft - (menuWidth / 2) + (buttonWidth / 2);
            
            menuContainer.scrollTo({
              left: scrollLeft,
              behavior: 'smooth'
            });
          }
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    menuCategories.forEach((category) => {
      const element = document.getElementById(`category-${category.id}`);
      if (element) observer.observe(element);
    });

    return () => observer.disconnect();
  }, []);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (isLangMenuOpen && !event.target.closest('.language-selector')) {
        setIsLangMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isLangMenuOpen]);

  return (
  <div className="min-h-screen relative text-amber-50">
    {/* Fondo de madera barnizada */}
    <div 
      className="fixed inset-0 -z-10"
      style={{
        backgroundImage: 'url(/images/wood-texture.webp)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    />
    
    {/* Capa oscura semi-transparente para legibilidad */}
    <div 
      className="fixed inset-0 -z-10 bg-gradient-to-b from-black/85 via-black/80 to-black/90"
    />
    
    
    
    {/* Brillo barnizado premium */}
    <div 
      className="fixed inset-0 -z-10"
      style={{
        background: 'radial-gradient(circle at 50% 0%, rgba(255, 191, 0, 0.08) 0%, transparent 60%)',
      }}
    />
      
      <nav className="fixed w-full bg-zinc-900/95 backdrop-blur-sm z-50 border-b border-amber-900/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center gap-3">
              <img src="images/logo-png.png" alt="logo" className='flex h-24'style={{filter: 'brightness(0) invert(1)'}} />
              <span className="pl-2 text-2xl font-bold text-amber-500">SOLO CARNES & AQUARIUM</span>
            </div>
              
            <div className="hidden md:flex space-x-8 items-center">
              <button onClick={() => scrollToSection('home')} className="text-amber-100 hover:text-amber-500 transition-colors">{t('nav.home')}</button>
              <button onClick={() => scrollToSection('menu')} className="text-amber-100 hover:text-amber-500 transition-colors">{t('nav.menu')}</button>
              <button onClick={() => scrollToSection('about')} className="text-amber-100 hover:text-amber-500 transition-colors">{t('nav.about')}</button>
              <button onClick={() => scrollToSection('salones')} className="text-amber-100 hover:text-amber-500 transition-colors">{t('nav.salones')}</button>
              <button onClick={() => scrollToSection('contact')} className="text-amber-100 hover:text-amber-500 transition-colors">{t('nav.contact')}</button>
              
              <div className="relative language-selector">
                <button 
                  onClick={() => setIsLangMenuOpen(!isLangMenuOpen)}
                  className="flex items-center gap-2 text-amber-100 hover:text-amber-500 transition-colors"
                >
                  <Globe size={20} />
                  <span className="text-xl">{languages.find(l => l.code === i18n.language)?.flag || '🌐'}</span>
                </button>
                
                {isLangMenuOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-zinc-800 rounded-lg shadow-xl border border-amber-900/30 py-2 z-50">
                    {languages.map((lang) => (
                      <button
                        key={lang.code}
                        onClick={() => changeLanguage(lang.code)}
                        className={`w-full px-4 py-2 text-left hover:bg-zinc-700 transition-colors flex items-center gap-3 ${
                          i18n.language === lang.code ? 'text-amber-500' : 'text-amber-100'
                        }`}
                      >
                        <span className="text-xl">{lang.flag}</span>
                        <span>{lang.name}</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden text-amber-500">
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden bg-zinc-800 border-t border-amber-900/20">
            <div className="px-4 py-4 space-y-3">
              <button onClick={() => scrollToSection('home')} className="block w-full text-left text-amber-100 hover:text-amber-500 transition-colors py-2">{t('nav.home')}</button>
              <button onClick={() => scrollToSection('menu')} className="block w-full text-left text-amber-100 hover:text-amber-500 transition-colors py-2">{t('nav.menu')}</button>
              <button onClick={() => scrollToSection('about')} className="block w-full text-left text-amber-100 hover:text-amber-500 transition-colors py-2">{t('nav.about')}</button>
              <button onClick={() => scrollToSection('salones')} className="block w-full text-left text-amber-100 hover:text-amber-500 transition-colors py-2">{t('nav.salones')}</button>
              <button onClick={() => scrollToSection('contact')} className="block w-full text-left text-amber-100 hover:text-amber-500 transition-colors py-2">{t('nav.contact')}</button>
              
              <div className="border-t border-amber-900/30 pt-3 mt-3">
                <p className="text-amber-400 text-sm mb-2 px-2">Idioma / Language</p>
                <div className="grid grid-cols-2 gap-2">
                  {languages.map((lang) => (
                    <button
                      key={lang.code}
                      onClick={() => changeLanguage(lang.code)}
                      className={`px-4 py-2 rounded-lg transition-colors flex items-center gap-2 justify-center ${
                        i18n.language === lang.code 
                          ? 'bg-amber-600 text-white' 
                          : 'bg-zinc-700 text-amber-100 hover:bg-zinc-600'
                      }`}
                    >
                      <span className="text-lg">{lang.flag}</span>
                      <span className="text-sm">{lang.name}</span>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>

      <section id="home" className="pt-20 min-h-screen flex items-center justify-center relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNiIgc3Ryb2tlPSIjZmZiZjAwIiBzdHJva2Utd2lkdGg9IjAuNSIgb3BhY2l0eT0iMC4xIi8+PC9nPjwvc3ZnPg==')] opacity-20"></div>
        
        <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 text-amber-500">
            {t('hero.title')}
          </h1>
          <p className="text-xl md:text-2xl mb-4 text-amber-100">
            {t('hero.subtitle')}
          </p>
          <p className="text-lg md:text-xl mb-12 text-zinc-400 max-w-2xl mx-auto">
            {t('hero.description')}
          </p>
          <button 
            onClick={() => scrollToSection('menu')}
            className="bg-amber-600 hover:bg-amber-700 text-white px-10 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 shadow-xl"
          >
            {t('hero.viewMenu')}
          </button>
        </div>
      </section>

      <section id="about" className="py-20 px-4 bg-zinc-800/50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-12 text-amber-500">{t('about.title')}</h2>
          <div className="grid md:grid-cols-2 gap-12 items-center">
            
            {/* Carousel */}
            <div className="relative">
              <div 
                className="relative h-96 rounded-lg overflow-hidden border-2 border-amber-900/30 group cursor-pointer bg-zinc-700/30"
                onClick={handleCarouselClick}
              >
                <img 
                  src={restaurantImages[currentImageIndex].src}
                  alt={restaurantImages[currentImageIndex].alt}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105 pointer-events-none"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div style={{ display: 'none' }} className="w-full h-full flex items-center justify-center bg-zinc-700/50">
                  <p className="text-zinc-500 text-center px-4">[ {restaurantImages[currentImageIndex].alt} ]</p>
                </div>
                
                {/* Botones de navegación */}
                <button
                  onClick={(e) => { e.stopPropagation(); prevImage(e); }}
                  className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all backdrop-blur-sm z-20"
                  aria-label="Imagen anterior"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                
                <button
                  onClick={(e) => { e.stopPropagation(); nextImage(e); }}
                  className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all backdrop-blur-sm z-20"
                  aria-label="Siguiente imagen"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>

                {/* Indicadores */}
                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-20">
                  {restaurantImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={(e) => { e.stopPropagation(); setCurrentImageIndex(index); }}
                      className={`w-2 h-2 rounded-full transition-all ${
                        index === currentImageIndex 
                          ? 'bg-amber-500 w-8' 
                          : 'bg-white/50 hover:bg-white/80'
                      }`}
                      aria-label={`Ir a imagen ${index + 1}`}
                    />
                  ))}
                </div>

                {/* Overlay de zoom */}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center pointer-events-none">
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity">
                    <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v6m3-3H7" />
                    </svg>
                  </div>
                </div>
              </div>

              {/* Thumbnails */}
              <div className="mt-4 grid grid-cols-5 gap-2">
                {restaurantImages.map((img, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentImageIndex(index)}
                    className={`relative h-16 rounded overflow-hidden border-2 transition-all ${
                      index === currentImageIndex 
                        ? 'border-amber-500 ring-2 ring-amber-500/50' 
                        : 'border-zinc-700 hover:border-amber-500/50'
                    }`}
                  >
                    <img 
                      src={img.src}
                      alt={img.alt}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                      }}
                    />
                    <div style={{ display: 'none' }} className="w-full h-full flex items-center justify-center bg-zinc-700">
                      <p className="text-xs text-zinc-500">{index + 1}</p>
                    </div>
                  </button>
                ))}
              </div>
            </div>

            <div className="space-y-6">
              <p className="text-lg text-zinc-300 leading-relaxed">
                {t('about.text1')}
              </p>
              <p className="text-lg text-zinc-300 leading-relaxed">
                {t('about.text2')}
              </p>
              <div className="grid grid-cols-3 gap-4 pt-6">
                <div className="text-center">
                  <p className="text-3xl font-bold text-amber-500">25+</p>
                  <p className="text-sm text-zinc-400">{t('about.years')}</p>
                </div>
                <div className="text-center">
                  <p className="text-3xl font-bold text-amber-500">100%</p>
                  <p className="text-sm text-zinc-400">{t('about.premium')}</p>
                </div>
                <div className="text-center">
                  <p className="text-3xl font-bold text-amber-500">5★</p>
                  <p className="text-sm text-zinc-400">{t('about.rating')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal de Galería */}
      {isGalleryOpen && (
        <div 
          className="fixed inset-0 bg-black/95 z-[100] flex items-center justify-center"
          onClick={closeGallery}
        >
          <button
            onClick={closeGallery}
            className="absolute top-4 right-4 text-white hover:text-amber-500 transition-colors z-10"
            aria-label="Cerrar galería"
          >
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); prevImage(e); }}
            className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 text-white p-4 rounded-full transition-all backdrop-blur-sm z-10"
            aria-label="Imagen anterior"
          >
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); nextImage(e); }}
            className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 text-white p-4 rounded-full transition-all backdrop-blur-sm z-10"
            aria-label="Siguiente imagen"
          >
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M9 5l7 7-7 7" />
            </svg>
          </button>

          <div className="w-full max-w-7xl px-4" onClick={(e) => e.stopPropagation()}>
            <img 
              src={restaurantImages[currentImageIndex].src}
              alt={restaurantImages[currentImageIndex].alt}
              className="w-full h-auto max-h-[85vh] object-contain rounded-lg"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div style={{ display: 'none' }} className="w-full h-96 flex items-center justify-center">
              <p className="text-white text-xl">[ {restaurantImages[currentImageIndex].alt} ]</p>
            </div>
            
            <div className="text-center mt-6">
              <p className="text-white text-lg font-semibold">{restaurantImages[currentImageIndex].alt}</p>
              <p className="text-zinc-400 mt-2">{currentImageIndex + 1} / {restaurantImages.length}</p>
            </div>
          </div>

          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-3">
            {restaurantImages.map((_, index) => (
              <button
                key={index}
                onClick={(e) => { e.stopPropagation(); setCurrentImageIndex(index); }}
                className={`w-3 h-3 rounded-full transition-all ${
                  index === currentImageIndex 
                    ? 'bg-amber-500 w-10' 
                    : 'bg-white/50 hover:bg-white/80'
                }`}
                aria-label={`Ir a imagen ${index + 1}`}
              />
            ))}
          </div>
        </div>
      )}
  
      <section id="menu" className="py-20 px-4 relative z-10">
          <div className="max-w-7xl mx-auto relative overflow-visible">
            <h2 className="text-4xl md:text-5xl font-bold text-center mb-4 text-amber-500">{t('menu.title')}</h2>
            <p className="text-center text-zinc-400 mb-8 text-lg">{t('menu.subtitle')}</p>
            
            <div className="sticky top-20 z-40 bg-zinc-900/98 backdrop-blur-md -mx-4 px-4 py-4 mb-12 border-y border-amber-900/20 shadow-lg overflow-visible">
              <div 
                ref={categoryMenuRef}
                className="flex gap-3 overflow-x-auto scrollbar-hide scroll-smooth"
                style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
              >
                {menuCategories.map((category) => (
                  <button
                    key={category.id}
                    id={`btn-${category.id}`}
                    onClick={() => scrollToCategory(category.id)}
                    className={`whitespace-nowrap px-6 py-3 rounded-full font-semibold transition-all flex-shrink-0 ${
                      activeCategory === category.id
                        ? 'bg-amber-600 text-white shadow-lg shadow-amber-900/50'
                        : 'bg-zinc-800 text-amber-100 hover:bg-zinc-700 border border-amber-900/30'
                    }`}
                  >
                    {t(`menu.categories.${category.id}`)}
                  </button>
                ))}
              </div>
            </div>
            
            <div className="overflow-hidden">
              {menuCategories.map((category) => {
                const isListCategory = ['vinos', 'cervezas', 'cocteleria', 'espumantes', 'jugos-bebidas'].includes(category.id);
                
                return (
                  <div key={category.id} id={`category-${category.id}`} className="mb-16 scroll-mt-40">
                    <h3 className="text-3xl font-bold mb-8 text-amber-400 border-b-2 border-amber-900/30 pb-4 break-words">
                      {t(`menu.categories.${category.id}`)}
                    </h3>
                    
                    {isListCategory ? (
                      // FORMATO DE LISTA PARA BEBIDAS
                      <div className="bg-zinc-800/50 rounded-lg border border-amber-900/20 p-4 md:p-8">
                        <div className="space-y-3">
                          {category.items.map((item, idx) => {
                            const itemData = t(`menuItems.${category.id}.${item.key}`, { returnObjects: true });
                            const hasMultiplePrices = itemData.priceShot && itemData.priceCombinado;
                            
                            return (
                              <div 
                                key={idx} 
                                className="flex justify-between items-center border-b border-amber-900/10 pb-3 hover:bg-zinc-700/30 px-2 md:px-4 py-2 rounded transition-colors gap-3 min-w-0"
                              >
                                <span className="text-amber-100 font-medium flex-1 text-sm md:text-base break-words min-w-0 overflow-hidden">
                                  {itemData.name || t(`menuItems.${category.id}.${item.key}.name`)}
                                </span>
                                <div className="flex-shrink-0 whitespace-nowrap ml-2">
                                  {hasMultiplePrices ? (
                                    <div className="flex flex-col items-end gap-1">
                                      <span className="text-amber-500 font-bold text-sm md:text-base flex items-center gap-1">
                                        <span className="text-xs text-amber-400">Shot:</span>
                                        {itemData.priceShot}
                                      </span>
                                      <span className="text-blue-400 font-bold text-sm md:text-base flex items-center gap-1">
                                        <span className="text-xs text-blue-300">Combinado:</span>
                                        {itemData.priceCombinado}
                                      </span>
                                    </div>
                                  ) : (
                                    <span className="text-amber-500 font-bold text-base md:text-lg">
                                      {item.price || itemData.price}
                                    </span>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      // FORMATO CON TARJETAS PARA COMIDAS
                      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {category.items.map((item, idx) => (
                          <div key={idx} className="bg-zinc-800/50 rounded-lg overflow-hidden border border-amber-900/20 hover:border-amber-600/50 transition-all hover:shadow-xl hover:shadow-amber-900/20">
                            <div className="bg-zinc-700/50 h-64 flex items-center justify-center border-b border-amber-900/20">
                              <img 
                                src={`/images/${item.imagen}`}
                                alt={t(`menuItems.${category.id}.${item.key}.name`)}
                                className="w-full h-full object-fill"
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  e.target.nextSibling.style.display = 'flex';
                                }}
                              />
                              <div style={{ display: 'none' }} className="w-full h-full flex items-center justify-center">
                                <p className="text-zinc-500 text-sm px-4 text-center">{item.imagen}</p>
                              </div>
                            </div>
                            <div className="p-5">
                              <div className="flex justify-between items-start mb-3">
                                <h4 className="text-xl font-semibold text-amber-100 flex-1">
                                  {t(`menuItems.${category.id}.${item.key}.name`)}
                                </h4>
                                <span className="text-amber-500 font-bold text-lg ml-3 flex-shrink-0">{item.price}</span>
                              </div>
                              <p className="text-sm text-zinc-400 leading-relaxed">
                                {t(`menuItems.${category.id}.${item.key}.desc`)}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section id="salones" className="py-20 px-4 z-0">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-amber-500">
              {t('salones.title')}
            </h2>
            <p className="text-xl text-zinc-400">
              {t('salones.subtitle')}
            </p>
          </div>

          {/* Grid de Salones */}
          <div className="grid md:grid-cols-2 gap-8 mb-16">
            {/* Salón Principal */}
            <div className="bg-zinc-800/50 rounded-lg overflow-hidden border border-amber-900/20 hover:border-amber-600/50 transition-all hover:shadow-xl hover:shadow-amber-900/20 group">
              <div className="h-64 bg-zinc-700/50 relative">
                <ImageCarousel 
                  images={[
                    '/images/salon-principal.webp',
                    '/images/salon_principal_1.jpg',
                    '/images/salon_principal_2.jpg'
                  ]}
                  alt="Salón principal"
                />
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="text-2xl font-bold text-amber-400">
                    {t('salones.spaces.principal.name')}
                  </h3>
                  <span className="bg-amber-600/20 text-amber-400 px-3 py-1 rounded-full text-sm font-semibold">
                    {t('salones.spaces.principal.capacity')}
                  </span>
                </div>
                <p className="text-zinc-300 mb-4 leading-relaxed">
                  {t('salones.spaces.principal.description')}
                </p>
                <div className="grid grid-cols-2 gap-2">
                  {['salones.spaces.principal.features.0', 'salones.spaces.principal.features.1', 
                    'salones.spaces.principal.features.2', 'salones.spaces.principal.features.3'].map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2 text-sm text-zinc-400">
                      <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      {t(feature)}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Exterior */}
            <div className="bg-zinc-800/50 rounded-lg overflow-hidden border border-amber-900/20 hover:border-amber-600/50 transition-all hover:shadow-xl hover:shadow-amber-900/20 group">
              <div className="h-64 bg-zinc-700/50 relative overflow-hidden">
                <ImageCarousel 
                  images={[
                    '/images/exterior_1.jpg',
                    '/images/exterior_2.jpg',
                    '/images/exterior_3.jpg',
                    '/images/exterior_4.jpg'
                  ]}
                  alt="Exterior"
                />
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="text-2xl font-bold text-amber-400">
                    {t('salones.spaces.exterior.name')}
                  </h3>
                  <span className="bg-purple-600/20 text-purple-400 px-3 py-1 rounded-full text-sm font-semibold">
                    {t('salones.spaces.exterior.capacity')}
                  </span>
                </div>
                <p className="text-zinc-300 mb-4 leading-relaxed">
                  {t('salones.spaces.exterior.description')}
                </p>
                <div className="grid grid-cols-2 gap-2">
                  {['salones.spaces.exterior.features.0', 'salones.spaces.exterior.features.1', 'salones.spaces.exterior.features.2'].map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2 text-sm text-zinc-400">
                      <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      {t(feature)}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Salon aquarium */}
            <div className="bg-zinc-800/50 rounded-lg overflow-hidden border border-amber-900/20 hover:border-amber-600/50 transition-all hover:shadow-xl hover:shadow-amber-900/20 group">
              <div className="h-64 bg-zinc-700/50 relative overflow-hidden">
                <div className="w-full h-full bg-gradient-to-br from-green-900/30 to-zinc-900/50 flex items-center justify-center">
                  <ImageCarousel 
                  images={[
                    '/images/salon_aquarium_1.jpg',
                    '/images/salon_aquarium_2.jpg',
                    '/images/salon_aquarium_3.jpg'
                  ]}
                  alt=""
                />
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="text-2xl font-bold text-amber-400">
                    {t('salones.spaces.salonAquarium.name')}
                  </h3>
                  <span className="bg-green-600/20 text-green-400 px-3 py-1 rounded-full text-sm font-semibold">
                    {t('salones.spaces.salonAquarium.capacity')}
                  </span>
                </div>
                <p className="text-zinc-300 mb-4 leading-relaxed">
                  {t('salones.spaces.salonAquarium.description')}
                </p>
                <div className="grid grid-cols-2 gap-2">
                  {['salones.spaces.salonAquarium.features.0', 'salones.spaces.salonAquarium.features.1', 
                    'salones.spaces.salonAquarium.features.2'].map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2 text-sm text-zinc-400">
                      <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      {t(feature)}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            

            {/* Lounge & Bar */}
            <div className="bg-zinc-800/50 rounded-lg overflow-hidden border border-amber-900/20 hover:border-amber-600/50 transition-all hover:shadow-xl hover:shadow-amber-900/20 group">
              <div className="h-64 bg-zinc-700/50 relative overflow-hidden">
                <ImageCarousel 
                  images={[
                    '/images/lounge.jpg',
                    '/images/barra.jpg'
                  ]}
                  alt="Barra"
                />
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="text-2xl font-bold text-amber-400">
                    {t('salones.spaces.lounge.name')}
                  </h3>
                  <span className="bg-blue-600/20 text-blue-400 px-3 py-1 rounded-full text-sm font-semibold">
                    {t('salones.spaces.lounge.capacity')}
                  </span>
                </div>
                <p className="text-zinc-300 mb-4 leading-relaxed">
                  {t('salones.spaces.lounge.description')}
                </p>
                <div className="grid grid-cols-2 gap-2">
                  {['salones.spaces.lounge.features.0', 'salones.spaces.lounge.features.1'].map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2 text-sm text-zinc-400">
                      <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      {t(feature)}
                    </div>
                  ))}
                </div>
              </div>
            </div>
             {/* Estacionamiento */}
            <div className="bg-zinc-800/50 rounded-lg overflow-hidden border border-amber-900/20 hover:border-amber-600/50 transition-all hover:shadow-xl hover:shadow-amber-900/20 group">
              <div className="h-64 bg-zinc-700/50 relative overflow-hidden">
                <div className="w-full h-full bg-gradient-to-br from-green-900/30 to-zinc-900/50 flex items-center justify-center">
                  <ImageCarousel 
                  images={[
                    '/images/estacionamiento.jpg',
                    '/images/estacionamiento_1.jpg',
                    '/images/estacinamiento_2.jpg'
                  ]}
                  alt=""
                />
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="text-2xl font-bold text-amber-400">
                    {t('salones.spaces.estacionamiento.name')}
                  </h3>
                  <span className="bg-green-600/20 text-green-400 px-3 py-1 rounded-full text-sm font-semibold">
                    {t('salones.spaces.estacionamiento.capacity')}
                  </span>
                </div>
                <p className="text-zinc-300 mb-4 leading-relaxed">
                  {t('salones.spaces.estacionamiento.description')}
                </p>
                <div className="grid grid-cols-2 gap-2">
                  {['salones.spaces.estacionamiento.features.0', 'salones.spaces.estacionamiento.features.1'].map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2 text-sm text-zinc-400">
                      <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      {t(feature)}
                    </div>
                  ))}
                </div>
              </div>
            </div>
             {/* Baños */}
            <div className="bg-zinc-800/50 rounded-lg overflow-hidden border border-amber-900/20 hover:border-amber-600/50 transition-all hover:shadow-xl hover:shadow-amber-900/20 group">
              <div className="h-64 bg-zinc-700/50 relative overflow-hidden">
                <div className="w-full h-full bg-gradient-to-br from-green-900/30 to-zinc-900/50 flex items-center justify-center">
                  <ImageCarousel 
                  images={[
                    '/images/bano.jpg',
                    '/images/bano_1_hombre.jpg',
                    '/images/bano_2_mujeres.jpg'
                  ]}
                  alt=""
                />
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="text-2xl font-bold text-amber-400">
                    {t('salones.spaces.bano.name')}
                  </h3>
                  <span className="bg-green-600/20 text-green-400 px-3 py-1 rounded-full text-sm font-semibold">
                    {t('salones.spaces.bano.capacity')}
                  </span>
                </div>
                <p className="text-zinc-300 mb-4 leading-relaxed">
                  {t('salones.spaces.bano.description')}
                </p>
                <div className="grid grid-cols-2 gap-2">
                  {['salones.spaces.bano.features.0', 'salones.spaces.bano.features.1'].map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2 text-sm text-zinc-400">
                      <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      {t(feature)}
                    </div>
                  ))}
                </div>
              </div>
            </div>



          </div> 

         
          {/* Sección de Eventos Especiales */}
          <div className="bg-gradient-to-r from-amber-900/20 to-zinc-900/20 rounded-2xl p-8 md:p-12 border border-amber-900/30">
            <div className="text-center mb-8">
              <h3 className="text-3xl md:text-4xl font-bold text-amber-400 mb-4">
                {t('salones.events.title')}
              </h3>
              <p className="text-xl text-zinc-300">
                {t('salones.events.description')}
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-4 mb-8">
              {['salones.events.types.0', 'salones.events.types.1', 'salones.events.types.2', 
                'salones.events.types.3'].map((type, idx) => (
                <div key={idx} className="flex items-center gap-3 bg-zinc-800/50 rounded-lg p-4 border border-amber-900/20">
                  <svg className="w-6 h-6 text-amber-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-zinc-300 font-medium">{t(type)}</span>
                </div>
              ))}
            </div>

            <div className="text-center">
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-amber-600 hover:bg-amber-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 shadow-xl inline-flex items-center gap-2"
              >
                {t('salones.cta')}
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>

      <section id="contact" className="py-20 px-4 bg-zinc-800/50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-4 text-amber-500">{t('contact.title')}</h2>
          <p className="text-center text-zinc-400 mb-12 text-lg">{t('contact.subtitle')}</p>
          
          <div className="grid md:grid-cols-2 gap-12">
            <div className="space-y-8">
              <div className="flex items-start gap-4">
                <MapPin className="w-6 h-6 text-amber-500 mt-1" />
                <div>
                  <h3 className="text-xl font-semibold mb-2 text-amber-100">{t('contact.address')}</h3>
                  <p className="text-zinc-400">Avda san Andrés 78 <br />Lomas de San Andrés, Concepcion</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <Phone className="w-6 h-6 text-amber-500 mt-1" />
                <div>
                  <h3 className="text-xl font-semibold mb-2 text-amber-100">{t('contact.phone')}</h3>
                  <p className="text-zinc-400">41-2480119</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <Mail className="w-6 h-6 text-amber-500 mt-1" />
                <div>
                  <h3 className="text-xl font-semibold mb-2 text-amber-100">{t('contact.email')}</h3>
                  <p className="text-zinc-400">contacto@solocarnes.cl</p>
                  <h3  className="text-zinc-400 pt-2">Reservas:</h3>
                  <p className='text-zinc-400'>reservas@solocarnes.cl</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <Clock className="w-6 h-6 text-amber-500 mt-1" />
                <div>
                  <h3 className="text-xl font-semibold mb-2 text-amber-100">{t('contact.schedule')}</h3>
                  <p className="text-zinc-400" style={{ whiteSpace: 'pre-line' }}>
                    {t('contact.scheduleText')}
                  </p>
                </div>
              </div>
            </div>
            
            <div className="space-y-6">
            {/* Mensaje de estado (éxito o error) */}
            {submitMessage.text && (
              <div className={`p-4 rounded-lg border ${
                submitMessage.type === 'success' 
                  ? 'bg-green-900/20 border-green-500/50 text-green-400' 
                  : 'bg-red-900/20 border-red-500/50 text-red-400'
              }`}>
                <div className="flex items-center gap-2">
                  {submitMessage.type === 'success' ? (
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  ) : (
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                  )}
                  <p className="font-medium">{submitMessage.text}</p>
                </div>
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-medium mb-2 text-amber-100">
                    {t('contact.form.name')} <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    className="w-full px-4 py-3 bg-zinc-900 border border-amber-900/30 rounded-lg focus:border-amber-500 focus:outline-none text-amber-100 transition-colors"
                    required
                    disabled={isSubmitting}
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium mb-2 text-amber-100">
                    {t('contact.form.email')} <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    className="w-full px-4 py-3 bg-zinc-900 border border-amber-900/30 rounded-lg focus:border-amber-500 focus:outline-none text-amber-100 transition-colors"
                    required
                    disabled={isSubmitting}
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium mb-2 text-amber-100">
                    {t('contact.form.phone')} <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    className="w-full px-4 py-3 bg-zinc-900 border border-amber-900/30 rounded-lg focus:border-amber-500 focus:outline-none text-amber-100 transition-colors"
                    required
                    disabled={isSubmitting}
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium mb-2 text-amber-100">
                    {t('contact.form.message')} <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    rows="4"
                    className="w-full px-4 py-3 bg-zinc-900 border border-amber-900/30 rounded-lg focus:border-amber-500 focus:outline-none text-amber-100 resize-none transition-colors"
                    required
                    disabled={isSubmitting}
                  ></textarea>
                </div>
                
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`w-full px-6 py-3 rounded-lg font-semibold transition-all transform shadow-lg flex items-center justify-center gap-2 ${
                    isSubmitting 
                      ? 'bg-amber-800 cursor-not-allowed' 
                      : 'bg-amber-600 hover:bg-amber-700 hover:scale-105'
                  } text-white`}
                >
                  {isSubmitting ? (
                    <>
                      <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      {t('contact.form.sending') || 'Enviando...'}
                    </>
                  ) : (
                    t('contact.form.send')
                  )}
                </button>
              </div>
            </form>
          </div>
          </div>
        </div>
      </section>

      <footer className="bg-zinc-900 py-8 px-4 border-t border-amber-900/20">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-zinc-500">© 2025 Restaurant SOLOCARNES & AQUARIUM. {t('footer.rights')}</p>
        </div>
      </footer>
    </div>
  );
};

export default RestaurantWebsite;